export default __webpack_public_path__ + "static/charmedSchoolbus-c27b9fd49dc0ba7ce10252f82931c764.svg";